import { ChangeDetectionStrategy, Component, Injector, Input } from '@angular/core';
import { Identity } from '@ducat-pro-wallets/swag-wallet';
import { provideValueAccessor, WrappedFormControlSuperclass } from '@s-libs/ng-core';

import { IdentitiesService } from '@dsh/api/wallet';

@Component({
    selector: 'dsh-identity-field',
    templateUrl: './identity-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [provideValueAccessor(IdentityFieldComponent)],
})
export class IdentityFieldComponent extends WrappedFormControlSuperclass<Identity['id']> {
    @Input() required = false;

    identities$ = this.identitiesService.identities$;

    constructor(injector: Injector, private identitiesService: IdentitiesService) {
        super(injector);
    }
}
